import { render } from "./ZamgRectangleCoord.vue?vue&type=template&id=156c2aa0&ts=true"
import script from "./ZamgRectangleCoord.vue?vue&type=script&lang=ts"
export * from "./ZamgRectangleCoord.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__